import styled from 'styled-components'

export const DataTableLink = styled.a`
  color: #000;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #0095e8;
    text-decoration: underline;
    transition: all 0.3s ease;
  }
`
